import { BackButton, Form, FormFullPhoneNumber, FormInput } from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileSecureMyOfferSeller = (props) => {
    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Form
                rowId={props.rowId}
                sectionCode='additionalSellerDetails'
                pageCode={props.pageCode}
                saveTooltipInfo={props.saveTooltipInfo}
                reduceTooltipInfoElement={props.reduceTooltipInfoElement}
                tooltipInfo={props.tooltipInfo}
                validationInfo={props.validationInfo}
                header={
                    <FormattedMessage
                        id={props.seller?.label || 'Profile_SecureMyOffer_AdditionalSellers_Seller.newSeller'}
                        defaultMessage={props.seller?.label || 'New Seller'}
                    />
                }
                label={<FormattedMessage id='Profile_SecureMyOffer_AdditionalSellers_Seller.sellerDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={props.saveEvent}
                cancelEvent={props.cancelEvent}
                validate={() => props.seller?.firstName && props.seller?.lastName}
            >
                <FormInput
                    fieldCode='firstName'
                    label={<FormattedMessage id='Profile_SecureMyOffer_AdditionalSellers_Seller.firstName' />}
                    value={props.seller?.firstName}
                    type='text'
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}firstName`, value })}
                    allowEdit
                    required
                />
                <FormInput
                    fieldCode='lastName'
                    label={<FormattedMessage id='Profile_SecureMyOffer_AdditionalSellers_Seller.lastName' />}
                    value={props.seller?.lastName}
                    type='text'
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}lastName`, value })}
                    allowEdit
                    required
                />
                <FormInput
                    fieldCode='email'
                    label={<FormattedMessage id='Profile_SecureMyOffer_AdditionalSellers_Seller.email' />}
                    value={props.seller?.email}
                    type='email'
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}email`, value })}
                    allowEdit
                />
                <FormFullPhoneNumber
                    fieldCode='phone'
                    label={<FormattedMessage id='Profile_SecureMyOffer_AdditionalSellers_Seller.phone' />}
                    value={props.seller?.phone}
                    changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}phone`, value })}
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileSecureMyOfferSeller;
